import { BottomOrRegularModal } from '@popsure/dirty-swan';
import { useModalContext } from 'context';
import React from 'react';
import StrapiRichText from 'strapi/components/StrapiRichText';
import { BlockComponentProps } from 'strapi/types/utils';

import styles from './style.module.scss';

const TextModal = ({
  block,
  onError,
}: BlockComponentProps<'marketing-website.text-modal'>) => {
  const { openModal, setOpenModal } = useModalContext();
  const { title, body, modalId } = block;

  if (!modalId) return onError('Missing modalId');
  if (!title) return onError('Missing title');
  if (!body) return onError('Missing body');

  return (
    <section className="text-modal-container">
      <BottomOrRegularModal
        isOpen={openModal === modalId}
        title={title}
        onClose={() => setOpenModal('')}
      >
        <div className={`p24 pt16 w100 ${styles.richTextContainer}`}>
          <StrapiRichText richText={body} />
        </div>
      </BottomOrRegularModal>
    </section>
  );
};

export default TextModal;
